// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[v-cloak][data-v-00289ec4] {\n\tdisplay: none;\n}\nlabel.required[data-v-00289ec4]:after {\n\tcontent: '*';\n\tcolor: red;\n}\n.controls[data-v-00289ec4] {\n  display: flex !important;\n  justify-content: space-between !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
